
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Guard, GuardType } from '@/store/dispatch/types';
import { namespace } from 'vuex-class';
import Multiselect from 'vue-multiselect';

const Dispatch = namespace('dispatch');

@Component({
  components: {
    'multiselect': Multiselect
  }
})
export default class GuardTypeSelector extends Vue {

  @Prop(Object) newGuard: Guard;

  @Dispatch.Getter('getGuardTypes') guardTypes!: GuardType[];
  @Dispatch.Action loadGuardTypes: any;
  
  selectedDispatchGuardTypeID: any = null;
  
  mounted() {
    this.loadGuardTypes();
    this.populateSelection();
  }

  async dispatchGuardTypeSelected(guardType: GuardType) {
    this.newGuard.dispatchGuardTypeID = guardType.dispatchGuardTypeID;
  }

  populateSelection() {
    if (this.newGuard.dispatchGuardTypeID === 0) {
      this.selectedDispatchGuardTypeID = this.guardTypes[0];
      this.newGuard.dispatchGuardTypeID = 1;
    }
    else {
      this.selectedDispatchGuardTypeID = this.guardTypes.find(x => x.dispatchGuardTypeID === this.newGuard.dispatchGuardTypeID);        
    }
  }
}
